import { createQueryKeys } from '@lukemorales/query-key-factory'

import { productTemplateService } from '@/domain/ProductTemplate'
import search from '@/pages/search'
import { searchService } from '@/domain/Search'

export const productTemplate = createQueryKeys('PT', {
    id: (id: string) => ({
        queryKey: ['id', id],
        queryFn: () => productTemplateService.getProductTemplateById(id),
    }),
    template: (barcode: string) => ({
        queryKey: ['barcode', barcode],
        queryFn: () => productTemplateService.retrieveByBarcode(barcode),
    }),
    products: (barcode: string) => ({
        queryKey: ['getRelatedProducts', barcode],
        queryFn: () =>
            productTemplateService.getProductTemplateProducts(barcode),
    }),
    categories: (handle: string) => ({
        queryKey: ['getRelatedCategory', handle],
        queryFn: () =>
            productTemplateService.getProductTemplateCategories(handle),
    }),
    new: () => ({
        queryKey: ['getNewest'],
        queryFn: () =>
            searchService.getSearchResults({
                sortBy: 'latest',
                itemsPerPage: 20,
                showOutOfStock: null,
                page: 1,
                minPrice: null,
            }),
    }),
})
